import React from 'react'

const Welcome = React.lazy(() => import('./views/pages/site/Site'))
const About = React.lazy(() => import('./views/pages/site/About'))
const Research = React.lazy(() => import('./views/pages/site/Research'))
const Aesthetic = React.lazy(() => import('./views/pages/site/Aesthetic'))
const Accelerator = React.lazy(() => import('./views/pages/site/Accelerator'))
const Cart = React.lazy(() => import('./views/pages/site/Cart'))
const Privacy = React.lazy(() => import('./views/pages/site/Privacy'))
const Terms = React.lazy(() => import('./views/pages/site/Terms'))
const Forum = React.lazy(() => import('./views/pages/site/Forum'))
const ForumFaculty = React.lazy(() => import('./views/pages/site/ForumFaculty'))
const ForumSchedule = React.lazy(() => import('./views/pages/site/ForumSchedule'))
const ForumRegistration = React.lazy(() => import('./views/pages/site/ForumRegistration'))
const Article = React.lazy(() => import('./views/pages/site/Article'))
const AestheticIndustryAssociation = React.lazy(() => import('./views/pages/site/AestheticIndustryAssociation'))
//const Gallery = React.lazy(() => import('./views/pages/site/Gallery'))
const Gallery2 = React.lazy(() => import('./views/pages/site/Gallery2'))
const Gallery3 = React.lazy(() => import('./views/pages/site/Gallery3'))
const Contact = React.lazy(() => import('./views/pages/site/Contact'))
const Colors = React.lazy(() => import('./views/theme/colors/Colors'))
const AxIncubator = React.lazy(() => import('./views/pages/site/AxIncubator'))

const siteRoutes = [
  { path: '/', exact: true, name: 'Home', component: Welcome },
  { path: '/about', exact: true, name: 'About', component: About },
  { path: '/article', exact: true, name: 'Article', component: Article },
  { path: '/cart', exact: true, name: 'Cart', component: Cart },
  { path: '/privacy-statement', exact: true, name: 'Privacy', component: Privacy },
  { path: '/terms-and-conditions', exact: true, name: 'Terms', component: Terms },
  { path: '/strategic-research', exact: true, name: 'Strategic Research', component: Research },
  { path: '/aesthetic-insights', exact: true, name: 'Aesthetic Insights', component: Aesthetic },
  { path: '/aesthetic-accelerator', exact: true, name: 'Aesthetic Accelerator', component: Accelerator },
  { path: '/forum', exact: true, name: 'The Aesthetic Forum', component: Forum },
  { path: '/forum-faculty-bios', exact: true, name: 'The Aesthetic Forum - Faculty Bios', component: ForumFaculty },
  { path: '/forum-schedule', exact: true, name: 'The Aesthetic Forum - Schedule', component: ForumSchedule },
  { path: '/forum-registration', exact: true, name: 'The Aesthetic Forum - Registration', component: ForumRegistration },
  { path: '/aesthetic-industry-association', exact: true, name: 'Aesthetic Industry Association', component: AestheticIndustryAssociation },
  //{ path: '/gallery', exact: true, name: 'Gallery', component: Gallery },
  { path: '/gallery', exact: true, name: 'Gallery', component: Gallery2 },
  { path: '/gallery/:videoId', name: 'Gallery', component: Gallery2 },
  { path: '/beauty', exact: true, name: 'The Beauty Show', component: Gallery3 },
  { path: '/beauty/:videoId', name: 'The Beauty Show', component: Gallery3 },
  { path: '/contact', exact: true, name: 'Contact', component: Contact },
  { path: '/theme', exact: true, name: 'Theme', component: Colors },
  { path: '/:articleSlug', exact: true, name: 'Article', component: Article },
  { path: '/ax-incubator', exact: true, name: 'Ax Incubator', component: AxIncubator },
];

export default siteRoutes
